import {observable, action} from 'mobx';
import base from '../../tool/base';
import {message} from 'antd';

const initState = {
  searchValue: {
    department: '',
    name: '',
    branch: '',
  }
};

export class RewardStore {
  @observable loading = false;
  @observable routes = [];
  @observable searchValue = initState.searchValue;
  @observable pagination = {
    // defaultCurrent: 1,
    pageSize: 10,
    total: 0,
    offset: 0,
    current: 1,
    showSizeChanger: true,
    showQuickJumper: true,
  }
  @observable lastestShare = [];

  constructor(routing) {
    this.routing = routing;
    this.getRoutes = this.getRoutes.bind(this);
    this.resetSearchValue = this.resetSearchValue.bind(this);
    this.callLastestShare = this.callLastestShare.bind(this);
  }

  @action
  getRoutes(params) {
    this.routes = [{
      key: '1',
      breadcrumbName: '云商店',
      path: '/'
    }];
    this.routes.push({
      key: '3',
      breadcrumbName: '最新分享',
      path: '/app/collect'
    });
  }

  resetSearchValue() {
    this.searchValue = initState.searchValue;
  }

  callLastestShare(params = {}) {
    if (!localStorage.me) {
      message.info("对不起，此功能暂无权限！请登录后使用！");
    } else {
      this.loading = true;
      let me = !!localStorage.me ? JSON.parse(localStorage.me) : {role: ""};
      params.offset = (this.pagination.current - 1) * this.pagination.pageSize;
      params = {...params,access_token:me.token.access_token, current: this.pagination.current, pageSize: this.pagination.pageSize};
      base.callApi('/v3/selectRank', 'GET', params, 'json', 'text').then((data) => {
        for (let i in data) {
          if (i !== 'total') {
            let len = Object.keys(data[i].app).length;
            data[i].hasMore = len > 10;
            data[i].pageSize = 10;
            data[i].current = 1;
          }
        }
        this.lastestShare = data;
        this.pagination.total = parseInt(data.total);
        this.loading = false;
      });
    }
  }

}


// WEBPACK FOOTER //
// ./src/stores/reward/RewardStore.js